import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { Scrollbars } from 'react-custom-scrollbars';
import Styles from './styles';
import EditableLabel from '../EditableLabel';

const EditorPanel = (props) => {
  const renderTitle = () => {
    if (props.titleEditable) {
      return <EditableLabel style={Styles.title}>{props.title}</EditableLabel>;
    }
    return <span style={Styles.title}>{props.title}</span>;
  };

  const renderDefaultHeader = () => (
    <div style={Styles.header}>
      <span style={Styles.title}>{renderTitle()}</span>
      <div style={{ flex: 1 }} />
      <span className="icon-questionmark" />
    </div>
  );

  const renderHeader = () => {
    if (props.renderHeader) {
      return props.renderHeader();
    }

    return renderDefaultHeader();
  };

  const renderFooter = () => {
    if (props.renderFooter) {
      return props.renderFooter();
    }

    return null;
  };

  const renderDefaultOverlayPanel = () => null;

  const renderOverlayPanel = () => {
    if (props.renderOverlayPanel) {
      return props.renderOverlayPanel();
    }

    return renderDefaultOverlayPanel();
  };

  return (
    <div style={{ ...Styles.wrapper, ...props.style }} onClick={props.onClick} role="presentation">
      {renderHeader()}
      <Scrollbars
        style={Styles.contents}
        renderTrackVertical={({ style, ...props }) => (
          <div {...props} style={{ ...style, ...Styles.track }} />
        )}
        renderThumbVertical={({ style, ...props }) => (
          <div {...props} style={{ ...style, ...Styles.thumb }} />
        )}
      >
        {props.children}
      </Scrollbars>
      {renderOverlayPanel()}
      {renderFooter()}
      <div style={[Styles.focus, props.hasFocus ? Styles.focusActive : {}]} />
    </div>
  );
};

EditorPanel.propTypes = {
  style: StylePropType,
  hasFocus: PropTypes.bool,
  title: PropTypes.string,
  titleEditable: PropTypes.bool,
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
  renderOverlayPanel: PropTypes.func,
  children: PropTypes.element,
  onClick: PropTypes.func,
};

EditorPanel.defaultProps = {
  style: {},
  hasFocus: true,
  title: 'Panel',
  titleEditable: false,
  renderHeader: null,
  renderFooter: null,
  renderOverlayPanel: null,
  children: null,
  onClick: () => {},
};

export default Radium(EditorPanel);



// WEBPACK FOOTER //
// ./src/components/EditorPanel/index.js